/* eslint-disable formatjs/no-literal-string-in-jsx */
'use client';
import { quicksand, sfProDisplay } from '@bazaar-marketplace/assets/fonts';
import * as Sentry from '@sentry/nextjs';
import { Button, ThemeProvider, AnimatedSticker } from '~/components';

import { hapticFeedback } from '@telegram-apps/sdk-react';
import { useRouter } from 'next/navigation';
import { SadPenguin } from './assets';

interface GlobalErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export function GlobalError({ error, reset }: GlobalErrorProps) {
  const router = useRouter();

  // Report error to Sentry
  Sentry.captureException(error);

  const handleRefresh = () => {
    if (hapticFeedback.isSupported()) {
      hapticFeedback.impactOccurred('medium');
    }
    reset();
    router.refresh();
  };

  return (
    <html className="h-full" lang="en" suppressHydrationWarning>
      <body className={`h-full ${sfProDisplay.variable} ${quicksand.variable} antialiased overscroll-none bg-black`}>
        <ThemeProvider attribute="class" defaultTheme="dark" disableTransitionOnChange enableSystem forcedTheme="dark">
          <div className="relative h-screen w-full bg-black">
            {/* Main Content */}
            <div className="flex flex-col h-full px-6 items-center justify-center">
              {/* Error Image */}
              <div className="mb-10">
                <div className="w-[180px] h-[180px]">
                  <AnimatedSticker autoplay loop src={SadPenguin} />
                </div>
              </div>

              {/* Text Content */}
              <div className="text-center mb-10 w-full">
                <h1
                  className="font-bold text-[32px] leading-[35px] text-white text-center mb-4"
                  style={{ fontFamily: 'Quicksand' }}
                >
                  Something went wrong
                </h1>
                <p
                  className="text-center text-base leading-[22px] text-white/60"
                  style={{ fontFamily: 'Quicksand', fontWeight: 700 }}
                >
                  There was a problem loading data
                </p>
              </div>

              {/* Try Again Button */}
              <Button className="w-full rounded-2xl py-4 px-6" variant="rainbow" onClick={handleRefresh}>
                Try again
              </Button>
            </div>

            {/* Home Indicator */}
            <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2">
              <div className="w-[139px] h-[5px] bg-white rounded-full"></div>
            </div>
          </div>
        </ThemeProvider>
      </body>
    </html>
  );
}
